import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {
  DeviceActivityModel,
  ICampaignDeviceData, IDeviceCalendarFullData
} from '../../../../models/device-activity.model';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {asyncScheduler, fromEvent, Observable, of, scheduled} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import * as moment from 'moment';

@UntilDestroy()
@Component({
  selector: 'app-device-activity-page',
  templateUrl: './device-activity.page.html',
  styleUrls: ['./device-activity.page.scss'],
})
export class DeviceActivityPage implements OnInit, AfterViewInit {
  private calendar!: DeviceActivityModel;
  calendarData: IDeviceCalendarFullData | null = null;
  @ViewChildren('headerDays', {read: ElementRef}) headerDays!: QueryList<ElementRef>;
  @ViewChild('mainWrapper', {read: ElementRef}) mainWrapper!: ElementRef;
  activityCoordinates = {
    startPoint: 0,
    endPoint: 0,
    visible: false,
  };
  windowResize$ = fromEvent(window, 'resize');
  moment = moment;

  @Input() set devicesActivity(value: ICampaignDeviceData) {
    if (!value) return;
    this.calendar = new DeviceActivityModel(value);
    this.initDeviceActivityWorker();
  }
  @Input() title = 'Device Activity';
  @Input() currentDate = moment().format('YYYY-MM-DD');
  @Input() devicesPerPage = 1;
  @Input() totalDevices = 0;
  currentPage = 1;
  @Output() onPageChange = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.windowResize$.pipe(
      untilDestroyed(this),
      switchMap(() => of(this.headerDays.toArray()))
    ).subscribe((item) => {
      if (!item.length) return;
      this.setDaysElCoordinates(item);
    });

    scheduled(this.headerDays.changes as Observable<QueryList<ElementRef>>, asyncScheduler).pipe(
      untilDestroyed(this),
      map((item) => item.toArray())
    )
      .subscribe((item) => {
        if (!item.length) return;
        this.setDaysElCoordinates(item);
      });
  }

  next(): void {
    this.calendar.nextPeriod();
  }

  back(): void {
    this.calendar.prevPeriod();
  }

  pageChangeEvent(page: number): void {
    this.currentPage = page;
    this.onPageChange.emit(page);
  }

  private setDaysElCoordinates(elements: ElementRef[]): void {
    const startPoint: number = elements
      .find(item => item.nativeElement.classList.contains('in-activity'))?.nativeElement.offsetLeft || 0;
    const endPoint: number = elements.reverse()
      .find(item => item.nativeElement.classList.contains('in-activity'))?.nativeElement.offsetLeft || 0;
    const cellWidth: number = elements[0].nativeElement.offsetWidth;
    const mainWrapperWidth = this.mainWrapper.nativeElement.offsetWidth;

    this.activityCoordinates = {
      startPoint,
      endPoint: mainWrapperWidth - (endPoint + cellWidth),
      visible: Boolean(startPoint >= 0 && endPoint > 0)
    };
  }

  private initDeviceActivityWorker(): void {
    this.calendar.getActivity$
      .pipe(untilDestroyed(this))
      .subscribe((calendarData) => {
        this.calendarData = calendarData;
      });
  }
}
